export const environment = {
  production: true,
  authorityApiUrl: 'https://authority-stage.tfagency.se/api',
  sentryDSN: 'https://219481e30cc8ebea3d261a41c1a42f3c@o4505385050898432.ingest.us.sentry.io/4507033897009156',
  sentryEnvironment: 'stage',
};
